import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { SK_TOAST_CUSTOM_COMPONENT_DATA } from '@ngx-strakit/cdk/controls/toast';

@Component({
  selector: 'inner-html-toast',
  templateUrl: './inner-html-toast.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InnerHtmlToastComponent {
  dataParam = inject<{ data: unknown }>(SK_TOAST_CUSTOM_COMPONENT_DATA);
  readonly data = null;

  constructor() {
    this.data = this.dataParam.data;
  }
}
